<template>
  <v-card height="250px">
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <h2 class="title">Top equipos demandados</h2>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="end" class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <!--
          <v-overflow-btn
            v-if="true"
            append-icon="arrow_drop_down"
            class="pa-0 ma-0 overflow-select-text"
            dense
            flat
            v-model="demandFilter"
            color="accent"
            label="MAYOR A MENOR DEMANDA"
            height="16"
            v-on:change="filterDemand(demandFilter)"
            :items="[
              {
                text: 'MAYOR A MENOR DEMANDA',
                value: 'demandDesc'
              },
              {
                text: 'MENOR A MAYOR DEMANDA',
                value: 'demandAsc'
              }
            ]"
          ></v-overflow-btn>
          -->
          <div class="filter font-weight-light">MAYOR A MENOR DEMANDA</div>
        </v-col>
      </v-row>
      <v-row no-gutters class="pa-0 ma-0">
        <v-col class="pa-0 ma-0">
          <v-simple-table height="170" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="pa-0 text-center">Modelo</th>
                  <th class="pa-0 text-center">Top</th>

                  <th class="pa-0 text-center">EQ</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(product, index) in productsDemanded"
                  v-bind:key="index"
                >
                  <td class="pa-0">{{ product.model }}</td>
                  <td class="pa-0 font-weight-light text-center">
                    {{ index + 1 }}
                  </td>
                  <td class="pa-0 text-center">{{ product.demanded }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      demandFilter: {
        text: "MAYOR A MENOR DEMANDA",
        value: "demandDesc"
      }
    };
  },

  computed: {
    ...mapState("machines", ["productsDemanded", "branchOffice"])
  },
  methods: {
    ...mapActions("machines", [
      "demandAsc",
      "demandDesc",
      "getDemandedProducts"
    ]),
    filterDemand(filter) {
      switch (filter) {
        case "demandAsc":
          this.demandAsc();
          break;
        case "demandDesc":
          this.demandDesc();
          break;
        default:
          break;
      }
    }
  },
  watch: {
    "$route.params.branchOffice": {
      handler: function(branch) {
        if (branch) {
          this.getDemandedProducts(branch);
        } else {
          this.getDemandedProducts();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="css" scoped>
.title {
  font-weight: 400 !important;
  color: black;
  font-size: 16px !important;
}
thead th {
  text-transform: uppercase;
  font-weight: 400;
}
tbody td {
  color: #808080;
}
.filter {
  text-align: right;
  font-size: 12px;
  letter-spacing: 0;
  color: #808080;
  opacity: 1;
}
</style>
